import { DatePipe } from '@angular/common';
import { Component, EventEmitter, Output, ViewChild, ElementRef, Input, inject } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDateRangePicker, MatDateRangeInput, MatStartDate, MatEndDate, MatDatepickerToggle, MatDatepickerToggleIcon } from '@angular/material/datepicker';
import { subDays } from 'date-fns';
import { ScheduleDatesFilterModel } from 'src/app/models/filter-date.model';
import { ToastService } from 'src/app/services/toast.service';
import { MatFormField, MatLabel, MatSuffix } from '@angular/material/input';
import { MatIcon } from '@angular/material/icon';

@Component({
    selector: 'app-range-dates',
    templateUrl: './range-dates.component.html',
    styleUrls: ['./range-dates.component.scss'],
    imports: [MatFormField, MatLabel, MatDateRangeInput, FormsModule, ReactiveFormsModule, MatStartDate, MatEndDate, MatDatepickerToggle, MatSuffix, MatIcon, MatDatepickerToggleIcon, MatDateRangePicker]
})
export class RangeDatesComponent {
  toastr = inject(ToastService);
  datepipe = inject(DatePipe);
  private readonly elementRef = inject(ElementRef);


  @ViewChild('picker') picker!: MatDateRangePicker<Date>;
  @Output() sendDates = new EventEmitter<ScheduleDatesFilterModel>();
  @Output() clickOutside = new EventEmitter<void>();
  @Input() keepCalendarOpen = true;
  dateForm = this.createReport();
  formatFrom = 'yyyy-MM-ddT00:00:00';
  formatTo = 'yyyy-MM-ddT23:59:59';
  dates: ScheduleDatesFilterModel = {
    from: '',
    to: '',
  };

  ngAfterViewInit() {
    this.picker.open();
  }

  createReport(): UntypedFormGroup {
    return new UntypedFormGroup({
      fromDate: new UntypedFormControl(null),
      toDate: new UntypedFormControl(null),
    });
  }

  applyFn() {
    if (this.dateForm.controls.toDate.value != null) {
      this.setDates(null);
    }
  }

  setDates(event: any) {
    let initDate = this.dateForm.controls.fromDate.value ?? '';
    let finalDate = this.dateForm.controls.toDate.value ?? '';

    if (initDate != '' && initDate.toString() == finalDate.toString()) {
      this.dates.from = initDate;
      this.dates.to = finalDate.setHours(23, 59, 59);
      this.sendDates.emit(this.dates);
    }

    if (initDate == '' && finalDate == '') {
      this.dates.from = initDate;
      this.dates.to = finalDate;
      this.sendDates.emit(this.dates);
    }

    if (initDate != '' && finalDate == '') {
      finalDate = this.datepipe.transform(Date.now(), this.formatTo);
      initDate = this.datepipe.transform(initDate, this.formatFrom);
      this.dates.from = initDate;
      this.dates.to = finalDate;
      this.sendDates.emit(this.dates);
    }

    if (initDate == '' && finalDate != '') {
      finalDate = this.datepipe.transform(finalDate, this.formatTo);
      let tempFinalDate = new Date(finalDate);
      let tempDate = subDays(tempFinalDate, 30);
      initDate = this.datepipe.transform(tempDate, this.formatFrom);
      this.dates.from = initDate;
      this.dates.to = finalDate;
      this.sendDates.emit(this.dates);
    }

    if (initDate != '' && finalDate != '') {
      if (finalDate < initDate) {
        return this.toastr.error(
          'Error',
          'La fecha inicial no puede ser posterior a la fecha final.'
        );
      } else {
        finalDate = this.datepipe.transform(finalDate, this.formatTo);
        initDate = this.datepipe.transform(initDate, this.formatFrom);
        this.dates.from = initDate;
        this.dates.to = finalDate;
        this.sendDates.emit(this.dates);
      }
    }
  }

  resetForm() {
    this.dateForm.reset();
  }

  //@HostListener('document:click', ['$event'])
  onClickOutside(event: Event) {
    const target = event.target as HTMLElement;

    if (
      !this.elementRef.nativeElement.contains(target) &&
      !target.closest('.footer') &&
      !target.closest('.mat-calendar-table') &&
      !target.closest('.mat-calendar') &&
      !target.closest('.mat-date-range-picker')
    ) {
      this.clickOutside.emit();
    }
  }

  onCalendarClosed() {
    if (this.keepCalendarOpen) setTimeout(() => this.picker.open(), 200);
  }
}
